import { TabBody, TabHeader } from '@/molecules/tab';

import { Tab } from './Tab';

export type TypeTab = typeof Tab & {
  Header: typeof TabHeader;
  Body: typeof TabBody;
};

(Tab as TypeTab).Header = TabHeader;
(Tab as TypeTab).Body = TabBody;

TabHeader.displayName = 'Tab.Header';
TabBody.displayName = 'Tab.Body';

export type { TypeTabProps } from './types';
export type { TypeTabBodyProps, TypeTabHeaderProps } from '@/molecules/tab';

export default Tab as TypeTab;
